module.exports = __webpack_public_path__ + "media/images/icons/icon_module_black-a818af486a5c206f69fb67a6af0b6580.svg";